export default (styles = {}) => {
  for (let i in styles) {
    if (typeof styles[i] === 'undefined') {
      delete styles[i]
    }
  }
  return styles
}



// WEBPACK FOOTER //
// ./~/_vux@2.9.0@vux/src/libs/clean-style.js